var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71566 7.99389C3.71566 5.63109 5.63109 3.71566 7.99389 3.71566C10.3567 3.71566 12.2721 5.63109 12.2721 7.99389C12.2721 10.3567 10.3567 12.2721 7.99389 12.2721C5.63109 12.2721 3.71566 10.3567 3.71566 7.99389ZM7.99389 2.38232C4.89471 2.38232 2.38232 4.89471 2.38232 7.99389C2.38232 11.0931 4.89471 13.6055 7.99389 13.6055C9.30326 13.6055 10.5079 13.157 11.4626 12.4053L14.7291 15.6719L15.6719 14.7291L12.4054 11.4625C13.157 10.5078 13.6055 9.30324 13.6055 7.99389C13.6055 4.89471 11.0931 2.38232 7.99389 2.38232Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.626d5042e19b9caa9cfe58548ec476af.svg";
export { ForwardRef as ReactComponent };